import { alpha, type SxProps, type Theme } from "@mui/material/styles";

import { instagramBrandColor } from "@/theme/customTokens";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1.5),
  p: theme.spacing(1.75),
  borderRadius: 2,
  bgcolor: "background.default",
  border: 1,
  borderColor: "transparent",
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: alpha(instagramBrandColor, 0.25),
    bgcolor: alpha(instagramBrandColor, 0.04),
  },
});

export const iconTile: SxProps<Theme> = {
  width: 40,
  height: 40,
  flex: "none",
  borderRadius: 1.5,
  bgcolor: alpha(instagramBrandColor, 0.1),
  color: instagramBrandColor,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const text: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.375),
  minWidth: 0,
});

export const title: SxProps<Theme> = {
  fontSize: "0.84375rem",
  fontWeight: 700,
};

export const description: SxProps<Theme> = {
  fontSize: "0.75rem",
  color: "text.secondary",
  lineHeight: 1.7,
};
